import React, {ReactElement} from "react"
import Lottie from "react-lottie-player"
import loader from "@ui/icons/common/Loader.json"

const Loader = ({size}: {size?: string | number}): ReactElement => {
  return (
    <div className="loader">
      <div className="back"></div>
      <Lottie loop play animationData={loader} style={{width: size}} />
    </div>
  )
}

export default Loader
